import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Stack } from 'components/Stack'
import { Footer } from 'components/Footer'
import { LoaderRoot, Wrapper } from './Loader.styles'
import { LoaderAnimation } from './LoaderAnimation'

type LoaderOwnProps = ComponentProps<typeof LoaderRoot>
export type LoaderProps = LoaderOwnProps & {
}

export const Loader = (_props: LoaderProps) => {
  const { t } = useTranslation()

  const header = <Header />

  return (
    <LoaderRoot>
      <Layout header={header} hideCTA>
        <Stack justifyContent="center">
          <Wrapper>
            <LoaderAnimation description={t('common:loader.description')} />
          </Wrapper>
        </Stack>
        <Footer />
      </Layout>
    </LoaderRoot>
  )
}

Loader.displayName = 'Loader'
